import { render, staticRenderFns } from "./AppDbTableSelectModal.vue?vue&type=template&id=284e938c"
import script from "./AppDbTableSelectModal.vue?vue&type=script&lang=js"
export * from "./AppDbTableSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports